import React from 'react';
import messages from "res/messages/farsi";
import StandardButton from "components/buttons/StandardButton";

import ICAppIcon from "res/images/app_icon.png";
import ICClearIcon from '@material-ui/icons/Clear';
import {useHistory} from "react-router-dom";

export default function DownloadApp(props) {

    const history = useHistory()

    return (<>
        {props.showStatus &&
        <table
            className="fullWidth card_blue_top_curve hideInLPT_showInFMS highZIndex_3 whiteColor"
            style={{position: "fixed", bottom: 0, height: "4.2em", opacity: "90%"}}
            onClick={() => {
                props.onClick(history)
            }}>
            <tbody>
            <tr>
                <td rowSpan={2}>
                    <img className="largeIcon marginTopSmall" src={ICAppIcon} alt=""/>
                </td>
                <td className="fullWidth">
                    <div className="largeTextBold">
                        {messages.downloadApp}
                    </div>
                </td>
                <td rowSpan={2}>
                    <StandardButton
                        icon={<ICClearIcon className="whiteColor"/>}
                        onClick={(e) => {
                            e.stopPropagation()
                            props.onCloseClicked()
                        }}/>
                </td>
            </tr>
            <tr>
                <td colSpan={3}>
                    <div className="largeText ">
                        {messages.usefullInApp}
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        }
    </>)
}